<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Contents">
<h1 class="toc_h"><span class="right_1" epub:type="pagebreak" id="page_vii" title="vii">CONTENTS</span></h1>
<p class="toc_fm"><a href="#/text/9780253053053_Preface#pre" id="spre"><i>Preface</i></a></p>
<p class="toc_fm"><a href="#/text/9780253053053_Introduction#intro" id="sintro">Introduction: Anthem of a Generation</a></p>
<p class="toc_ch_be"><a href="#/text/9780253053053_Chapter01#ch1" id="sch1"><span class="toc-pad">1.</span> Songs Rather Than Screams</a></p>
<p class="toc_ch_be"><span href="#/text/9780253053053_Chapter02#ch2" id="sch2" title="Link target outside of Sample"><span class="toc-pad">2.</span> Something That Is Ours . . . and Still Authentically Islam</span></p>
<p class="toc_ch_be"><span href="#/text/9780253053053_Chapter03#ch3" id="sch3" title="Link target outside of Sample"><span class="toc-pad">3.</span> It Is … a Problem of Human Rights</span></p>
<p class="toc_ch_be"><span href="#/text/9780253053053_Chapter04#ch4" id="sch4" title="Link target outside of Sample"><span class="toc-pad">4.</span> She Reppin’ Islam and She Gives It a Meaning</span></p>
<p class="toc_ch_be"><span href="#/text/9780253053053_Chapter05#ch5" id="sch5" title="Link target outside of Sample"><span class="toc-pad">5.</span> Enemy of the State</span></p>
<p class="toc_ch_be"><span href="#/text/9780253053053_Chapter06#ch6" id="sch6" title="Link target outside of Sample"><span class="toc-pad">6.</span> Keeping It Real … Keeping It Cool</span></p>
<p class="toc_ch_ent"><span href="#/text/9780253053053_References#ref" id="sref" title="Link target outside of Sample"><i>References</i></span></p>
<p class="toc_ch_en"><span href="#/text/9780253053053_Index#index" id="sindex" title="Link target outside of Sample"><i>Index</i></span><span class="right_1" epub:type="pagebreak" id="page_viii" title="viii"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253053053_Contents.vue?3d40ce36